import React from "react";
import "./ContactPage.css";
import { motion } from "framer-motion";
import { fadeIn } from "../../variants";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";

const contactMethods = [
  {
    icon: EmailIcon,
    title: "Email",
    value: "contact@101bestwhitelabel.com",
    link: "mailto:contact@101bestwhitelabel.com",
    color: "#0D65D9",
  },
  {
    icon: PhoneIcon,
    title: "Phone",
    value: "+1 (555) 123-4567",
    link: "tel:+15551234567",
    color: "#0D65D9",
  },
  {
    icon: WhatsAppIcon,
    title: "WhatsApp",
    value: "+1 (555) 123-4567",
    link: "https://wa.me/15551234567",
    color: "#25D366",
  },
  {
    icon: TelegramIcon,
    title: "Telegram",
    value: "@101bestwhitelabel",
    link: "https://t.me/101bestwhitelabel",
    color: "#0088cc",
  },
];

const ContactRow2 = () => {
  return (
    <div className="contact-row2-container">
      <motion.div
        variants={fadeIn("up", 0.2)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.2 }}
        className="contact-methods-title"
      >
        <div
          className="row-title"
          style={{ fontSize: "clamp(32px, 4.5vw, 64px)" }}
        >
          GET IN TOUCH
        </div>
        <div className="description" style={{ marginTop: "16px" }}>
          Choose your preferred way to reach us
        </div>
      </motion.div>

      <div className="contact-methods-grid">
        {contactMethods.map((method, index) => {
          const IconComponent = method.icon;
          return (
            <motion.a
              key={index}
              href={method.link}
              target={method.link.startsWith("http") ? "_blank" : "_self"}
              rel={method.link.startsWith("http") ? "noopener noreferrer" : ""}
              className="contact-method-card"
              variants={fadeIn("up", 0.2 + index * 0.1)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.2 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <div
                className="contact-card-icon"
                style={{ backgroundColor: method.color }}
              >
                <IconComponent sx={{ fontSize: 48, color: "#FFFFFF" }} />
              </div>
              <div className="contact-card-title">{method.title}</div>
              <div className="contact-card-value">{method.value}</div>
            </motion.a>
          );
        })}
      </div>
    </div>
  );
};

export default ContactRow2;
